// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__oiXu3","rootCenter":"LoadMoreObserver_rootCenter__1kHyT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2xyI9"};